<template>
  <signin-content></signin-content>
</template>
<script>
import SigninContent from "@/components/SigninContent.vue";

export default {
  name: "LinkookLiveSignin",
  components: {
    SigninContent,
  },
};
</script>
